import { lazyRouteComponent } from '@tanstack/react-router';

export const notFoundPageLoadable = lazyRouteComponent(() =>
  import('../../ui/not-found-page').then((m) => ({ default: m.NotFoundPage })),
);
